import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import SliderSection from '../../custom/sections/SliderSection';
import ImageRight from '../../custom/sections/ImageRight';
import ImageLeft from '../../custom/sections/ImageLeft';
import HomeContent from '../../../constatns/services';
import SelectableImageRight from '../../custom/sections/SelectableImageRight';
import HeaderSection from '../../custom/sections/HeaderSection';
//import { Dialog, Classes, AnchorButton } from "@blueprintjs/core";
import './index.css';



class Services extends Component {
  constructor(props) {
    super(props);
    this.state = { dialog : true }
    this.messageDialogResult = this.messageDialogResult.bind(this)
  }

  componentDidMount(){

  }

  messageDialogResult(){
    this.setState({dialog : false})
  }

  render() {
    const { lang } = this.props;
    //const { dialog } = this.state;

    return (
      <div id='home-page-sec' className='page-padding'>
        <HeaderSection lang={lang}/>
        <ImageRight lang={lang} content={HomeContent.rightImage}/>
        <ImageLeft lang={lang} content={HomeContent.leftImageTop}/>
        <SliderSection lang={lang}/>
        <ImageLeft lang={lang} content={HomeContent.leftImageBottom}/>
        <SelectableImageRight lang={lang} content={HomeContent.selectableImage} responsive/>
        {/* <Dialog icon={null} onClose={this.messageDialogResult} canEscapeKeyClose={true} enforceFocus={true} isOpen={dialog} usePortal={true}>
          <div className='home-dialog-longin-steps-wrapper'>
            <div className={Classes.DIALOG_BODY}>
              <p className='home-dialog-longin-steps-wrapper-text'>
                <h3>{lang === 'fa' ?'راهکار ورود به بورس ویو تا رفع اختلالات اینترنت':''}</h3>
                <p className='home-dialog-longin-steps-text'>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    <div>{lang === 'fa' ?'کلیک کنید':''}</div>
                    <b style={{margin:'0 3px'}}>{lang === 'fa' ?'"ورود با نام کاربری و رمز ورود"':''}</b>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    <div style={{margin:'0 3px'}}>{lang === 'fa' ?'روی دکمه':''}</div>
                    <b style={{margin:'0 3px'}}>{lang === 'fa' ?'"ورود به برنامه"':''}</b>
                    <div>{lang === 'fa' ?'پس از زدن آیکون':''}</div>
                  </div>
                </p>
                <p style={{display: 'flex', justifyContent: 'center'}}>
                  <div>{lang === 'fa' ?'خود را به طور کامل وارد نمایید':''}</div>
                  <b style={{margin:'0 3px'}}>{lang === 'fa' ?'"ایمیل" ':''}</b>
                  <div>{lang === 'fa' ?'در بخش نام کاربری':''}</div>
                </p>
                <p style={{display: 'flex', justifyContent: 'center'}}>
                  <div>{lang === 'fa' ?'را وارد نمایید':''}</div>
                  <b style={{margin:'0 3px'}}>{lang === 'fa' ?'123456pP':'123456pP'}</b>
                  <div>{lang === 'fa' ?'و در بخش رمز عبور':''}</div>
                </p>
              </p>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <AnchorButton style={{ width: '100px' }} className={Classes.INTENT_PRIMARY} onClick={this.messageDialogResult}>
                  {lang === 'fa' ?'باشه':'OK'}
                </AnchorButton>
              </div>
            </div>
          </div>
        </Dialog > */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Services);
